module.exports = __webpack_public_path__ + "media/14.a9d28752.mp3";